import { api } from '../../actions';

const reconcileMessages = (newer, older) => {
    const cache = {};

    for (const [index, message] of Object.entries(newer)) {
        cache[message._id] = index;
    }

    const result = Array.from(newer);

    for (const message of older) {
        const idx = cache[message._id];

        if (idx !== undefined) {
            result[idx] = message;
        } else {
            result.push(message);
        }
    }

    return result.sort((a, b) => b.received - a.received);
};

function reduce(state = { hasNext: true, next: null, items: [] }, action) {
    switch (action.type) {
        case api.conversations.messages.successType:
            return {
                ...state,
                hasNext: action.result.messages.hasNext,
                next: action.result.messages.next,
                items:
                    action.query && action.query.next
                        ? reconcileMessages(state.items, action.result.messages.results)
                        : [...action.result.messages.results],
            };
        case api.conversations.sendMessage.successType:
        case api.conversations.sendAttachment.successType:
        case api.conversations.assign.successType:
        case api.conversations.assignMe.successType:
            return {
                ...state,
                items: action.result.messages.concat(state.items),
            };
        case api.listenNewMessages.type:
            return {
                ...state,
                items: reconcileMessages(action.payload, state.items),
            };
        default:
            return state;
    }
}

export default (state = {}, action) => {
    switch (action.type) {
        case api.conversations.messages.successType:
        case api.conversations.sendMessage.successType:
        case api.conversations.sendAttachment.successType:
        case api.conversations.assign.successType:
        case api.conversations.assignMe.successType:
        case api.listenNewMessages.type:
            return {
                ...state,
                [action.contactId]: reduce(state[action.contactId], action),
            };
        default:
            return state;
    }
};
